package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.ast.ThemeFileAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.diag.DslError

/**
 * 主题文件收集 Pass：把所有顶级 `theme { ... }` 文件按文件名（[ThemeFileAst.schemeName]）
 * 注册到 [ThemeRegistry]。scheme 名重复时报错，仅第一个生效。
 *
 * 同时注册 tokenNodes（诊断位置）与 metadata（目录展示）。
 */
class ThemeCollectorPass(
    private val registry: ThemeRegistry,
    private val diag: DiagnosticCollector,
) {

    fun collect(themes: List<ThemeFileAst>) {
        for (file in themes) {
            val scheme = file.schemeName
            if (scheme.isBlank()) {
                diag.error(
                    DslError.E001_LEX_ERROR,
                    file.position,
                    "theme 文件名为空，无法推导 scheme 名",
                )
                continue
            }
            if (registry.lookup(scheme) != null) {
                diag.error(
                    DslError.E001_LEX_ERROR,
                    file.position,
                    "theme scheme '$scheme' 重复注册",
                )
                continue
            }
            registry.registerWithNodes(
                scheme,
                LinkedHashMap(file.tokens),
                file.tokenNodes,
                file.metadata,
            )
        }
    }
}
